import { DeviceTabletIcon, CircleStackIcon, ShieldCheckIcon, WifiIcon } from '@heroicons/react/24/outline'

export const pilaresData = [
    {
        key: 'equipos',
        number: '01',
        icon: DeviceTabletIcon,
        image: '/eqespec.png',
        cta: { to: '/catalogo' },
        // highlighted: true,
    },
    {
        key: 'soporte',
        number: '02',
        icon: ShieldCheckIcon,
        image: '/soporte.png',
        cta: { to: '/soporte' },
    },
    {
        key: 'swrya',
        number: '03',
        icon: CircleStackIcon,
        image: '/software.png',
        cta: { to: '/swrya' },
    },
]

export const verticalesActivasData = [
    {
        key: 'retail',
        name: 'Retail',
        cardCaption: 'Piso de venta',
        image: '/retail.png',
        description: 'Ten un inventario confiable en tienda: controla mermas y el acomodo de productos, con la venta y el stock conectados en un mismo sistema.',
        tags: ['VENTAS', 'ACOMODO DE TIENDA', 'RFID'],
        kit: 'Kit Retail: terminal de piso, impresora de etiquetas de precio, lector de mostrador.',
        link: '/vertical/retail',
    },
    {
        key: 'manufactura',
        name: 'Manufactura',
        cardCaption: 'Línea de producción',
        image: '/manofactura.png',
        description: 'Da seguimiento a cada lote y número de serie, desde el consumo de materiales hasta el producto terminado.',
        tags: ['PRODUCCIÓN', 'RASTREO'],
        kit: 'Kit Manufactura: terminal industrial, impresora de etiqueta resistente, lector fijo de línea.',
        link: '/vertical/manufacture',
    },
    {
        key: 'logistica',
        name: 'Transporte y logística',
        cardCaption: 'Andén de carga',
        image: '/transportlogic.png',
        description: 'Controla entradas y salidas al ritmo del andén, con embarques exactos y evidencia de cada entrega.',
        tags: ['ENTRADAS', 'SALIDAS', 'MOVILIDAD'],
        kit: 'Kit Logística: terminal de andén, impresora móvil, lector de largo alcance.',
        link: '/vertical/transport',
    },
]

export const kitsData = [
    {
        key: 'retail',
        vertical: 'Retail',
        tag: 'RETAIL',
        cardCaption: 'Kit retail: terminal, impresora de precio, lector',
        image: '/kitpisoventa.png',
        cta: { to: '/contact', state: 'cotizar-equipo' },
    },
    {
        key: 'manufactura',
        vertical: 'Manufactura',
        tag: 'MANUFACTURA',
        cardCaption: 'Kit manufactura: terminal industrial, lector fijo',
        image: '/kitlineatraz.png',
        cta: { to: '/contact', state: 'cotizar-equipo' },
    },
    {
        key: 'logistica',
        vertical: 'Transporte y logística',
        tag: 'LOGÍSTICA',
        cardCaption: 'Kit logística: terminal de andén, impresora móvil',
        image: '/kitandenreparto.png',
        cta: { to: '/contact', state: 'cotizar-equipo' },
    },
]

export const diferenciadorFeatureKeys = ['distribucion', 'asesoria', 'reparacion', 'swrya']

export const clientesLogosData = [
    { name: 'Dogotuls', src: '/dogotuls.png' },
    { name: 'Dolores Market', src: '/doloresmkt.png' },
    { name: 'Farmacias del Ahorro', src: '/fa.png' },
    { name: 'Frialsa', src: '/frialsa.png' },
    { name: 'General Mills', src: '/gnrlmills.png' },
    { name: 'Hutchison Ports', src: '/hports.png' },
    { name: 'Liverpool', src: '/lvpool.png' },
    { name: 'Maersk', src: '/maersk.png' },
    { name: 'Mars', src: '/mars.png' },
    { name: 'Mattel', src: '/mattel.png' },
    { name: 'MRM', src: '/mrm.png' },
    { name: 'P&G', src: '/pg.png' },
    { name: 'Villacero', src: '/villacero.png' },
]

export const estructuraData = [
    { title: 'VisionTec', lead: 'Matriz.', description: 'Distribuidor autorizado de equipo para identificación y captura de datos: venta, mantenimiento y reparación.' },
    { title: 'SWRYA', lead: 'Software propio, opcional:', description: 'el sistema para controlar tu inventario, que corre directo sobre el equipo cuando lo necesitas.' },
    { title: 'ADSUMUS', lead: 'Empresa hija de servicio,', description: 'con centro de reparaciones propio.' },
]

export const salidasData = [
    { key: 'cotizarEquipo', icon: DeviceTabletIcon, highlighted: true },
    { key: 'cotizarReparacion', icon: ShieldCheckIcon },
    { key: 'diagnosticoRfid', icon: WifiIcon },
    { key: 'conocerSwrya', icon: CircleStackIcon },
]
